type PlaybackControls = {
  pause: () => void;
  seek: (time: number) => void;
  play: () => void;
};

export function syncPlaybackToTime(
  time: number,
  wasPlaying: boolean,
  controls: PlaybackControls
): void {
  if (wasPlaying) controls.pause();
  controls.seek(time);
  if (wasPlaying) controls.play();
}
